import { BasicMetadata, BroIdMetadata, EditMetadata } from "./MetaData";
import { Task } from "./Task";

export const deliveryContextGMNOptions = [
  { value: "kaderrichtlijnWater", label: "Kader richtlijn water" },
  {
    value: "drinkwaterwet",
    label: "Drinkwaterwet",
  },
  {
    value: "ontgrondingenwet",
    label: "Ontgrondingenwet",
  },
  {
    value: "waterschapswet",
    label: "Waterschapswet",
  },
  {
    value: "waterwetGrondwaterzorgplicht",
    label: "Waterwet grondwaterzorgplicht",
  },
  {
    value: "waterwetOnttrekkingInfiltratie",
    label: "Waterwet onttrekking infiltratie",
  },
  {
    value: "waterwetPeilbeheer",
    label: "Waterwet peilbeheer",
  },
  {
    value: "waterwetStrategischGrondwaterbeheer",
    label: "Waterwet strategisch grondwaterbeheer",
  },
  {
    value: "waterwetWaterstaatswerkAanlegWijziging",
    label: "Waterwet waterstaatswerk aanleg wijziging",
  },
  {
    value: "waterwetWaterstaatswerkBeheer",
    label: "Waterwet waterstaatswerk beheer",
  },
  {
    value: "waterwetWaterstaatswerkIngreep",
    label: "Waterwet waterstaatswerk ingreep",
  },
  {
    value: "wetNatuurbescherming",
    label: "Wet natuurbescherming",
  },
  {
    value: "archiefoverdracht",
    label: "Archiefoverdracht",
    onlyImbroA: true,
  },
] as const;
export const deliveryContextGMNOptionsType = deliveryContextGMNOptions.map(({ value }) => value);
export type DeliveryContextGMNOptions = (typeof deliveryContextGMNOptionsType)[number];

export const translateDeliveryContext = (sendValue: DeliveryContextGMNOptions) => {
  const optionTranslation = deliveryContextGMNOptions.find(({ value }) => value === sendValue);

  if (optionTranslation && "label" in optionTranslation && optionTranslation.label)
    return optionTranslation.label;
  return sendValue;
};

export const monitoringPurposeOptions = [
  {
    label: "Strategisch beheer kwaliteit landelijk",
    value: "strategischBeheerKwaliteitLandelijk",
  },
  {
    label: "Strategisch beheer kwantiteit landelijk",
    value: "strategischBeheerKwantiteitLandelijk",
  },
  {
    label: "Strategisch beheer kwaliteit regionaal",
    value: "strategischBeheerKwaliteitRegionaal",
  },
  {
    label: "Strategisch beheer kwantiteit regionaal",
    value: "strategischBeheerKwantiteitRegionaal",
  },
  {
    label: "Beheersing stedelijk gebied",
    value: "beheersingStedelijkGebied",
  },
  {
    label: "Gevolgen onttrekking kwaliteit",
    value: "gevolgenOnttrekkingKwaliteit",
  },
  {
    label: "Gevolgen onttrekking kwantiteit",
    value: "gevolgenOnttrekkingKwantiteit",
  },
  {
    label: "Gevolgen peilbeheer",
    value: "gevolgenPeilbeheer",
  },
  {
    label: "Gevolgen waterstaatswerk kwaliteit",
    value: "gevolgenWaterstaatswerkKwaliteit",
  },
  {
    label: "Gevolgen waterstaatswerk kwantiteit",
    value: "gevolgenWaterstaatswerkKwantiteit",
  },
  {
    label: "Waterstaatswerk beheer kwaliteit",
    value: "waterstaatswerkBeheerKwaliteit",
  },
  {
    label: "Waterstaatswerk beheer kwantiteit",
    value: "waterstaatswerkBeheerKwantiteit",
  },
  {
    label: "Veiligstelling grondwater kwaliteit",
    value: "veiligstellingGrondwaterKwaliteit",
  },
  {
    label: "Veiligstelling grondwater kwantiteit",
    value: "veiligstellingGrondwaterKwantiteit",
  },
  {
    label: "Waterstaatkundige verzorging kwaliteit",
    value: "waterstaatkundigeVerzorgingKwaliteit",
  },
  {
    label: "Waterstaatkundige verzorging kwantiteit",
    value: "waterstaatkundigeVerzorgingKwantiteit",
  },
  {
    label: "Veiligstelling drinkwatervoorziening kwaliteit",
    value: "veiligstellingDrinkwatervoorzieningKwaliteit",
  },
  {
    label: "Veiligstelling drinkwatervoorziening kwantiteit",
    value: "veiligstellingDrinkwatervoorzieningKwantiteit",
  },
  {
    label: "Gevolgen ontgronding",
    value: "gevolgenOntgronding",
  },
  {
    value: "natuurbescherming",
    label: "Natuurbescherming",
  },
  {
    value: "natuurbeheer",
    label: "Natuurbeheer",
  },
  {
    label: "Onbekend",
    value: "onbekend",
    onlyImbroA: true,
  },
] as const;

export const monitoringPurposeOptionsType = monitoringPurposeOptions.map(({ value }) => value);
export type MonitoringPurposeOptions = (typeof monitoringPurposeOptionsType)[number];

export const groundwaterAspectOptions = [
  {
    value: "kwaliteit",
    label: "Kwaliteit",
  },
  {
    value: "kwantiteit",
    label: "Kwantiteit",
  },
  {
    value: "onbekend",
    label: "Onbekend",
  },
] as const;
export const groundwaterAspectOptionsType = groundwaterAspectOptions.map(({ value }) => value);
export type GroundwaterAspectOptions = (typeof groundwaterAspectOptionsType)[number];

export type RegistrationMeasuringPoint = {
  measuringPointCode: string;
  broId: string;
  tubeNumber: string;
};

// FUTURE: Should we add dateToBeCorrected?
// We need a way to define the original date, as it is currently not possible to track this.
// Should check what features can have this as well, to make sure these can be created.

export type MeasuringPoint = {
  measuringPointCode: string;
  broId: string;
  tubeNumber: string;
  eventDate: string;
};

type GMNStartRegistrationData = {
  objectIdAccountableParty: string;
  name: string;
  deliveryContext: DeliveryContextGMNOptions;
  monitoringPurpose: MonitoringPurposeOptions;
  groundwaterAspect: GroundwaterAspectOptions;
  startDateMonitoring: string;
  measuringPoints: RegistrationMeasuringPoint[];
};

export const gmnEventOptions = [
  { value: "GMN_MeasuringPoint", label: "MeetpuntToevoegen" },
  { value: "GMN_MeasuringPointEndDate", label: "MeetpuntEindDatum" },
  { value: "GMN_TubeReference", label: "BuisVerwijzing" },
] as const;

export const gmnEventOptionsType = gmnEventOptions.map(({ value }) => value);
export type GmnEventType = (typeof gmnEventOptionsType)[number];

export type EditGMNMeasuringPointData = MeasuringPoint & {
  eventType: GmnEventType;
};

type GMNClosureData = {
  endDateMonitoring: string;
};

export type CreateGMNTask = Task<GMNStartRegistrationData, BasicMetadata>;
export type EditGMNTask = Task<GMNStartRegistrationData, EditMetadata>;

export type EditGMNMeasuringPointTask = Task<EditGMNMeasuringPointData, EditMetadata>;

export type GMNClosureTask = Task<GMNClosureData, BroIdMetadata>;
export interface GMNMonitoringPointTask {
  metadata: BroIdMetadata;
  measuringPointsFile: Blob;
}
